import { handlePurchaseDatatableRow } from "../purchase_invoices/purchase_invoice_channel/datatable_row_processing";
import { updatePurchaseMobileCardWithOcrResponse } from "../purchase_invoices/purchase_invoice_channel/mobile_card_processing";

const purchaseInvoiceChannel = () => {
  const purchasePage = document.getElementById("purchases_table");

  if (purchasePage) {
    App.cable.subscriptions.create(
      {
        channel: "PurchaseInvoiceChannel",
        stream_name: "datatable:update",
      },
      {
        received: (data) => {
          if (document.getElementById("mobile_purchase_invoices")) {
            updatePurchaseMobileCardWithOcrResponse(data);
          } else {
            handlePurchaseDatatableRow(data);
          }
        },
      }
    );
  }
};

export { purchaseInvoiceChannel };
